import React from 'react'

export default function NothingToShow(props) {
  return (
    <div className={`nothing-to-show ${props.text ? "mb-5" : "mb-0"}`}>
      <p className='p-0 m-0'>{props.text ? props.text : "Sorry! Nothing To Show"}</p>
    </div>
  )
}
